// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'medicalRecordsTheme',
    themes: {
      medicalRecordsTheme: {
        dark: false,
        colors: {
          doorMainColor: '#0095d9',
          doorAccentColor: '#0170BF',
        }
      }
    }
  }
})
